import graph from "./graph";
import Reject from "./Reject";
import Attachments from "./Attachments";

import jMoment from "moment-jalaali";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { isEmptyObject } from "helpers/formatObject";
import { useLazyQuery, useMutation } from "@apollo/client";
import { Stack, Button, Typography, CircularProgress } from "@mui/material";
import {
  NewDialog,
  CustomList,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function ActivateLab({ id, title, refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [done, { loading: updating }] = useMutation(graph.done.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { status, lab } = res;
        if (res) {
          setFormData({
            status,
            lab,
          });
        }
      }
    } catch (error) {}
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await done({
        context: {
          serviceName: graph.done.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          id,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.done.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);


  return (
    <>
      <Button size="small" color="info" onClick={onOpen} variant="contained">
        بررسی
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          {loading ? <Loaading /> : <Content data={formData?.lab} />}
        </NewDialogContent>
        <NewDialogActions>
          {(formData?.status === "TODO" || formData?.status === "DOING") && (
            <>
              <Reject id={id} refetch={refetch} />

              <Button
                autoFocus
                size="medium"
                color="success"
                variant="contained"
                sx={{ minWidth: 80 }}
                disabled={updating}
                onClick={onSubmit}
              >
                {updating ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  "قبول درخواست"
                )}
              </Button>
            </>
          )}
        </NewDialogActions>
      </NewDialog>
    </>
  );
}

function Loaading() {
  return (
    <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
      <CircularProgress size={20} color="inherit" />
      <Typography align="center" variant="caption" color="text.disabled">
        در حال بارگذاری...
      </Typography>
    </Stack>
  );
}

function Content({ data = {} }) {
  const {
    id,
    media = [],
    title,
    status,
    register_date,
    registered_number,
    is_active,
    tellphone,
    postal_code,
    address,
    national_identifier,
  } = data;

  const license = media.find((x) => x.collection_name === "license");

  const ceoMelliBack = media.find(
    (x) => x.collection_name === "ceo-melli-back"
  );
  const ceoMelliFront = media.find(
    (x) => x.collection_name === "ceo-melli-front"
  );

  return (
    <Stack p={1} rowGap={1} bgcolor="background.paper">
      <Stack direction="row" columnGap={1}>
        <Attachments media={license} label="پروانه فعالیت" />
      </Stack>
      <Stack direction="row" columnGap={1}>
        <Attachments
          media={ceoMelliFront}
          label="تصویر روی کارت ملی"
          caption="صاحب پروانه"
        />
        <Attachments
          media={ceoMelliBack}
          label="تصویر پشت کارت ملی"
          caption="صاحب پروانه"
        />
      </Stack>
      <CustomList
        data={{
          title,
          value: status?.title,
          children: [
            {
              title: "شناسه ملی",
              value: national_identifier,
            },
            {
              title: "شماره ثبت",
              value: registered_number,
            },
            {
              title: "تاریخ ثبت",
              value: jMoment(register_date).format("jYYYY/jMM/jDD") || "-",
            },
            {
              title: "تلفن",
              value: tellphone,
            },
            {
              title: "کدپستی",
              value: postal_code,
            },
            {
              title: "آدرس",
              value: address,
            },
          ],
        }}
      />
    </Stack>
  );
}
